import React from "react";
import linkedin from "./linkedin.png";
import github from "./github.png";
import skills from "./skills.png"
import "./Contact.css"

export default function Contact() {
    return (
        <div>
            <ul className="Contact-list">
                <li><h3>Contact</h3></li>
                <li><a href="https://www.linkedin.com/in/lauravava/" rel="noreferrer" target="_blank"><img src={linkedin} alt="linkedin"  className="Linkein-image"/></a></li>
                <li><a href="https://github.com/lauravavz" rel="noreferrer" target="_blank" ><img src={github} alt="github" className="Github-image"/></a></li>
                <li><h4>This site was created using the following</h4></li>
            </ul>
            <img className="Apps-image" src={skills} alt="apps"/>
        </div>
    )
}